
<div class="col-12" *ngFor="let pendingRequest of pendingContractAccountRequests || []">
  <div class="alert alert-success" *ngIf="!pendingRequest.error"><span class="font-weight-bold float-left">Pending Contract Account Creation:  &nbsp;</span><span class="float-left"><span>{{ pendingRequest.contractAccountName }}</span></span>
    <div class="clearfix"></div>
  </div>
  <div class="alert alert-danger" *ngIf="pendingRequest.error">
    <div class="row">
      <div class="col-11 pb-2"><span class="font-weight-bold float-left">Please validate error message(s). If further assistance is required submit a ticket.</span></div>
      <div class="col"><span class="float-right">
          <button class="close" type="button" (click)="removePendingRequest(pendingRequest.filename)"><span> &times;</span></button></span></div>
    </div>
    <div class="row">
      <div class="col"><span class="font-weight-bold float-left">ERROR Contract Account:  &nbsp;</span><span class="font-weight-bold float-left">{{ pendingRequest.contractAccountName }} -  &nbsp;</span><span class="float-left"><span>{{(pendingRequest && pendingRequest.statusInformation && pendingRequest.statusInformation.errorMessage) || 'Unknown'}}</span></span></div>
    </div>
    <div class="row break-word">
      <ul *ngIf="pendingRequest &amp;&amp; pendingRequest.statusInformation &amp;&amp; pendingRequest.statusInformation.errors &amp;&amp; pendingRequest.statusInformation.errors.length">
        <li *ngFor="let error of pendingRequest.statusInformation.errors"><b>{{error.kind}}</b><i>  (count</i><i> {{error.count}}</i><i>)  -</i><i *ngIf="!error.message.includes('connection error')">{{error.message}}</i><i *ngIf="error.message.includes('connection error')">Communication between TMC and downstream systems is temporarily unavailable, please try again later. If issue persists contact&nbsp;<a class="alert-link" href="javascript:void(0);" (click)="showSupportModal()">support.</a></i></li>
      </ul>
    </div>
    <error-details [details]="pendingRequest.statusInformation.details.Details" *ngIf="pendingRequest &amp;&amp; pendingRequest.statusInformation &amp;&amp; pendingRequest.statusInformation.details"></error-details>
  </div>
</div>
<div class="row">
  <div class="col-md-12 justify-content-md-center">
    <div class="col-md-12 p-0">
      <error [error]="error"></error>
    </div>
  </div>
</div>
<div class="col-12">
  <div class="row">
    <div class="col-9">
      <list-controls [pageName]="&quot;ContractAccounts&quot;" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
    </div>
    <div class="col-3">
      <button class="btn btn-outline-primary" id="createContractAccount" type="button" (click)="createContractAccount()">Create Contract Account</button>
    </div>
  </div>
  <table class="table table-responsive customer-table">
    <thead>
      <tr class="table-header-with-controls">
        <th>Selection</th>
        <th>Contract Account Name</th>
        <th>Contract Account ID</th>
        <th>Status</th>
        <th class="actions">Show Details</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="contractAccountsDisplay">
        <ng-container *ngFor="let account of contractAccountsDisplay; let idx = index;">
          <tr [ngStyle]="{'font-weight': account.contractAccountId &amp;&amp; account.contractAccountId === defaultContractAccountId ? 'bold' : 'normal'}">
            <td class="form-group">
              <div class="form-check">
                <input class="form-check-input" *ngIf="account.caStatus !== 'Pending'" type="checkbox" name="selectedCustomerChk" id="selectedCustomerChk{{idx}}" ngbTooltip="Select contract account" (change)="mapContractAccount(account.contractAccountId)" [disabled]="account.isCASelected || disableSelection" [checked]="account.isCASelected || mappedCA.includes(account.contractAccountId)">
              </div>
            </td>
            <td class="name">{{account.contractAccountName}}</td>
            <td>{{account.contractAccountId}}</td>
            <td>{{account.caStatus}}  </td>
            <td class="text-center"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show contract account details" (click)="toggleExpandedContractAccount(account.contractAccountName,account.contractAccountId)"><span class="icon oi oi-chevron-bottom" *ngIf="expandedContractAccountIdName !== (account.contractAccountId || account.contractAccountName)"></span><span class="icon oi oi-chevron-top" *ngIf="expandedContractAccountIdName === (account.contractAccountId || account.contractAccountName)"></span></a></td>
          </tr>
          <ng-container *ngIf="expandedContractAccountIdName === (account.contractAccountId || account.contractAccountName)">
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.accountDeterminationId">Account Determination ID</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.accountDeterminationId"><i>Account Determination ID</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.accountDeterminationId}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.businessPartner">Customer Business Partner ID</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.businessPartner"><i>Customer Business Partner ID</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.businessPartner}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.currency">Currency</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.currency"><i>Currency</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.currency}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.contractAccountCategory">Contract Account Category ID</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.contractAccountCategory"><i>Contract Account Category ID</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.contractAccountCategory}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.paymentTerms">Payment Terms</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.paymentTerms"><i>Payment Terms</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.paymentTerms}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.incomingPaymentMethod">Incoming Payment Method</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.incomingPaymentMethod"><i>Incoming Payment Method</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.incomingPaymentMethod}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.billToParty">Bill To Party</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.billToParty"><i>Bill To Party</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.billToParty}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.alternatePayer">Alternate Payer</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.alternatePayer"><i>Alternate Payer</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.alternatePayer}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.correspondenceVariant">Correspondence Variant</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.correspondenceVariant"><i>Correspondence Variant</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.correspondenceVariant}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.accountClass">Account Class</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.accountClass"><i>Account Class</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.accountClass}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.companyCodeGroup">Company Code Group</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.companyCodeGroup"><i>Company Code Group</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.companyCodeGroup}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.standardCompanyCode">Standard Company Code</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.standardCompanyCode"><i>Standard Company Code</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.standardCompanyCode}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.outgoingPaymentMethod">Outgoing Payment Method</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.outgoingPaymentMethod"><i>Outgoing Payment Method</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.outgoingPaymentMethod}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.invoiceScheduling">Invoice Scheduling</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.invoiceScheduling"><i>Invoice Scheduling</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.invoiceScheduling}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr *ngIf="POR507_TMC || POR507_2_1_TMC">
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div>Exchange Rate Type</div>
                  <div class="text-secondary"></div>
                  <div class="border-bottom text-secondary">{{(contractAccountDetail.exchangeRateType?contractAccountDetail.exchangeRateType:'Standard')}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2" *ngIf="contractAccountDetail.exchangeRateType == 'Custom'">
                <div class="form-group">
                  <div>Exchange Rate</div>
                  <div class="text-secondary"></div>
                  <div class="border-bottom text-secondary">{{(contractAccountDetail.exchangeRate)}}&nbsp;    </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="contractAccountDetail.correspondenceRecipient || contractAccountDetail.correspondenceType">
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.correspondenceRecipient">Correspondence Recipient</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.correspondenceRecipient"><i>Correspondence Recipient</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.correspondenceRecipient}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.correspondenceType">Correspondence Type</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.correspondenceType"><i>Correspondence Type</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.correspondenceType}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr *ngIf="contractAccountDetail.incomingCreditCard || contractAccountDetail.billingCycle">
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.incomingCreditCard">Incoming Credit Card</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.incomingCreditCard"><i>Incoming Credit Card</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.incomingCreditCard}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.billingCycle">Billing Cycle</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.billingCycle"><i>Billing Cycle</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.billingCycle}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr *ngIf="contractAccountDetail.startDateOfFirstBillingPeriod || contractAccountDetail.contractAccountNumberInLegacy">
              <td class="border-top-0"></td>
              <td class="border-top-0">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.startDateOfFirstBillingPeriod">Start Date of First Billing Period</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.startDateOfFirstBillingPeriod"><i>Start Date of First Billing Period</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.startDateOfFirstBillingPeriod}}&nbsp;</div>
                </div>
              </td>
              <td class="border-top-0" colspan="2">
                <div class="form-group">
                  <div *ngIf="contractAccountDetail.contractAccountNumberInLegacy">Contract Account Number in Legacy</div>
                  <div class="text-secondary" *ngIf="!contractAccountDetail.contractAccountNumberInLegacy"><i>Contract Account Number in Legacy</i></div>
                  <div class="border-bottom text-secondary">{{contractAccountDetail.contractAccountNumberInLegacy}}&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr *ngIf="account.caStatus=='Pending'">
              <td class="border-top-0"></td>
              <td class="border-top-0"> </td>
              <td class="border-top-0" colspan="2">
                <div class="modal-footer" style="border-top:0px">
                  <button class="btn btn-outline-secondary" type="button" title="Reject" (click)="rejectCA(account.contractAccountName)">Reject</button>
                  <button class="btn btn-primary" type="button" title="Approve" (click)="createContractAccount(account.contractAccountName, contractAccountDetail)">Approve</button>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
      <tr *ngIf="!contractAccountsDisplay || contractAccountsDisplay.length === 0">
        <td colspan="4">
          <p class="text-center empty-table-message">There are no contract account to display.</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>